<template>
  <VListItem
    :disabled="!!userStore.impersonator"
    class="text-decoration-none pl-2"
    prepend-icon="menu_book"
    :title="t('navigationMenu.userManagement')"
    link
    role="listitem"
    @click="redirectToTum"
  />
  <VTooltip
    v-if="!isExpanded"
    activator="parent"
    location="right"
    :aria-label="t('navigationMenu.userManagement')"
  >
    {{ t('navigationMenu.userManagement') }}
  </VTooltip>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { teamworksRedirectPaths } from '@/utils/constants';
import { datadogLogs } from '@datadog/browser-logs';
import { useAppSwitcher } from '@/composables/useAppSwitcher';
import { TEAMWORKS_APP_SLUGS } from '@teamworksdev/vuetify';
import { useUserStore } from '@/stores/userStore';

defineProps<{
  isExpanded: boolean;
}>();

const { t } = useI18n();

const userStore = useUserStore();
const appSwitcher = useAppSwitcher();

const redirectToTum = () => {
  if (!appSwitcher.value.hasApp(TEAMWORKS_APP_SLUGS.HUB)) {
    datadogLogs.logger.error('[The Navigation Menu] unable to redirect to User Management');
    return;
  }

  appSwitcher.value.switch('hub', {
    redirect: teamworksRedirectPaths.TUM,
    redirect_with_token: 'true',
  });
};
</script>
